export default "__VITE_ASSET__t_4u9sxg__"